import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardHeader,
  CardBody,
  InputGroup
} from 'reactstrap';

const FeatureTable = () => {
  const [features, setFeatures] = useState([
    {
      id: '1',
      name: 'Basic Appointment Scheduling',
      category: 'Appointment Management',
      description: 'Schedule and manage basic appointments'
    },
    {
      id: '2',
      name: 'Recurring Appointments',
      category: 'Appointment Management',
      description: 'Set up recurring appointments with reminders'
    },
    {
      id: '3',
      name: 'Payment Integration',
      category: 'Billing',
      description: 'Collect payments securely online'
    }
  ]);

  const [categories, setCategories] = useState(['Appointment Management', 'Billing']);
  const [modalOpen, setModalOpen] = useState(false);
  const [newFeature, setNewFeature] = useState({ name: '', category: '', description: '' });
  const [newCategory, setNewCategory] = useState('');

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleAddFeature = () => {
    if (!newFeature.name || !newFeature.category) return;
    const newItem = {
      id: Date.now().toString(),
      ...newFeature
    };
    setFeatures([...features, newItem]);
    setNewFeature({ name: '', category: '', description: '' });
    toggleModal();
  };

  const handleAddCategory = () => {
    if (newCategory && !categories.includes(newCategory)) {
      setCategories([...categories, newCategory]);
      setNewCategory('');
    }
  };

  // Group features by category
  const groupedFeatures = categories.map((cat) => ({
    category: cat,
    items: features.filter((f) => f.category === cat)
  }));

  return (
    <Container className="mt-4" fluid>
      <Card>
        <CardHeader>
          <Row className="mb-3">
            <Col>
              <div>
                <h3 className="mb-1">Feature Management</h3>
                <p className="text-muted mb-0">Manage your features, categories.</p>
              </div>
            </Col>
            <Col className="text-end">
              <Button color="primary" onClick={toggleModal}>
                + Add Feature
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <Row className="mb-3">
            <Col md={12}>
              <Form>
                <FormGroup>
                  <Label for="newCategory" className="me-2">
                    New Category
                  </Label>
                  <InputGroup>
                    <Input
                      type="text"
                      id="newCategory"
                      value={newCategory}
                      onChange={(e) => setNewCategory(e.target.value)}
                      placeholder="Enter category name"
                    />
                    <Button color="primary" onClick={handleAddCategory}>
                      Add Category
                    </Button>
                  </InputGroup>
                </FormGroup>
              </Form>
            </Col>
          </Row>

          {groupedFeatures.map((group) => (
            <div key={group.category} className="mb-4">
              <h5>{group.category}</h5>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>Feature Name</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {group.items.length > 0 ? (
                    group.items.map((feature) => (
                      <tr key={feature.id}>
                        <td>{feature.name}</td>
                        <td>{feature.description}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center">
                        No features yet
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          ))}
        </CardBody>
        {/* Add Feature Modal */}
        <Modal isOpen={modalOpen} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Add Feature</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="featureName">Feature Name</Label>
                <Input
                  id="featureName"
                  value={newFeature.name}
                  onChange={(e) => setNewFeature({ ...newFeature, name: e.target.value })}
                  placeholder="Enter feature name"
                />
              </FormGroup>
              <FormGroup>
                <Label for="featureCategory">Category</Label>
                <Input
                  type="select"
                  id="featureCategory"
                  value={newFeature.category}
                  onChange={(e) => setNewFeature({ ...newFeature, category: e.target.value })}
                >
                  <option value="">Select category</option>
                  {categories.map((cat, idx) => (
                    <option key={idx} value={cat}>
                      {cat}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="featureDesc">Description</Label>
                <Input
                  type="textarea"
                  id="featureDesc"
                  value={newFeature.description}
                  onChange={(e) => setNewFeature({ ...newFeature, description: e.target.value })}
                  placeholder="Enter description"
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleAddFeature}>
              Save
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Card>
    </Container>
  );
};

export default FeatureTable;
